import { createContext } from 'react';
import type { IWorkflowError } from 'utils/errors/workflowErrors';

export type MessageLines = string[];

export type ErrorDetailsWithSummary = Readonly<{
  hasSummaryFromErrorMessages: true;
  errorMessages?: IWorkflowError[];
  shouldUseRejectionCode?: boolean;
  technicalError?: string;
  formattedSummaryMessages: MessageLines[];
}>;

export type ErrorDetailsWithoutSummary = Readonly<{
  hasSummaryFromErrorMessages: false;
  errorMessages?: IWorkflowError[];
  shouldUseRejectionCode?: boolean;
  technicalError?: string;
}>;

export type ErrorDetails = ErrorDetailsWithSummary | ErrorDetailsWithoutSummary;

export const ErrorMessagesContext = createContext<ErrorDetails>({
  hasSummaryFromErrorMessages: false,
});
